import { apiClient } from '@/lib/api-client';

export interface NavItem {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
  group?: string;
}

export interface MeContext {
  user: {
    id: string;
    email: string;
    name: string;
    memberships: Array<{ tenantId: string; tenantName: string; role: string }>;
  };
  activeTenant: { tenantId: string; role: string };
  permissions: string[];
  isPlatformAdmin: boolean;
  modules: string[];
  nav: NavItem[];
}

export async function getContext(): Promise<MeContext> {
  const { data } = await apiClient.get<MeContext>('/me/context');
  return data;
}
